module.exports = __webpack_public_path__ + "static/img/plug5.0e7f2ac8.webp";